<template>
  <div class="home">
    <el-backtop target=".home" :bottom="100">
    <div
      style="{
        height: 80px;
        width: 80px;
      }"
    >
      <img src="../assets/hddb.png" alt="">
    </div>
  </el-backtop>
    <div class="daohang">
      <el-row type="flex" class="row" justify="space-between">
        <el-col :span="4"><div class="grid-content bg-purple"><a @click="show=true"  href="#home"><img style="margin-top: 10px;" src="../assets/logo.png" alt=""></a></div></el-col>
        <el-col :span="16">
          <el-row :gutter="20" justify="end" >
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=true" href="#home">首页</a></el-col>
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=true" href="#home1">产品与服务</a></el-col>
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=true" href="#home2">解决方案 </a></el-col>
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=true" href="#home3">技术能力 </a></el-col>
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=true" href="#home4">合作客户 </a></el-col>
            <el-col :span="4" :offset="0" align="right" class="tiaoz"><a @click="show=false" href="#home5">关于我们 </a></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="banner" id="home" v-show="show">
      <el-row type="flex" class="row" justify="space-between">
        <el-col :span="12">
          <div class="col1">汇安有智</div>
          <div class="col2">企业风险评估解决方案</div>
          <div class="col3">信贷流程自动化 · 风控模型精准化 · 服务内容模块化</div>
          <div class="col4">为合作客户提供精准覆盖的产品和流程设计，提升客户整体风控能力</div>
          <div class="col5"  @click="dialogFormVisible = true">申请试用</div>
        </el-col>
        <el-col :span="12">
          <img src="../assets/banner.jpg" alt="">
        </el-col>
      </el-row>
    </div>
    <div class="chanping" id="home1" v-show="show">
      <div class="rowall">
        <el-row :gutter="20" justify="center">
          <el-col :span="24" :offset="0" align="center">
            <div class="cpyfw">产品与服务</div>
          </el-col>
          <el-col :span="24" :offset="0" align="center">
            <div class="cpyfwsm">汇安有智依托大数据、人工智能以及机器学习等技术，打造创新型新业务平台，为机构的业务提供高效稳定的服务保障</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" justify="space-around">
          <el-col :span="14" :offset="0">
            <img src="../assets/img-cp.png" alt="" class="img">
          </el-col>
          <el-col :span="8" :offset="2">
            <div class="cp1">企业资信评估</div>
            <div class="cp2">传统通过纯人工进行信息收集、风险评估的方式，要提升风控能力需要投入更多的人力成本。基于汇安有智的大数据风控管理等技术在风险识别、评估、预警以及控制方面拥有更多优势</div>
            <div class="cp3">产品功能</div>
            <div class="cp4">· 企业全息画像</div>
            <div class="cp5">包含企业税务信息、发票信息、工商信息、社保、反欺诈信息以及企业司法信息的全面真实情况</div>
            <div class="cp6">· 企业资信能力情况</div>
            <div class="cp7">通过汇安有智的大数据与人工智能技术深挖企业更多属性，多方面精准体现企业资信情况</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" :offset="0" align="center">
            <div class="cpys">产品优势</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="rowf">
          <el-col :span="6" :offset="0">
            <div class="ys1">
              <div class="tit">业务流程全覆盖</div>
              <div class="con">支持灵活配置可以快速满足各种不同的中小企业信贷经营模式，包含贷前资信验证系统、贷中智能审批辅助决策系统、贷后风险自动预警系统，有效降低人工操作风险</div>
            </div>
          </el-col>
          <el-col :span="6" :offset="0">
            <div class="ys2">
              <div class="tit">海量 、全面数据维度</div>
              <div class="con">通过权威、合规的数据源、互联网信息采集和自然语言处理等技术手段，提供企业数据维度全方位覆盖，积累形成内生行业数据仓库，有效加强风险感知和预警能力</div>
            </div>
          </el-col>
          <el-col :span="6" :offset="0">
            <div class="ys3">
              <div class="tit">风险预警实时高效</div>
              <div class="con">利用MRS Kafka / Stom等高性能流式集群能力，解决每秒数万条实时舆情信息的实时采集和分析能力，做到毫秒级延迟，同时可对多数据源进行处理分析</div>
            </div>
          </el-col>
          <el-col :span="6" :offset="0">
            <div class="ys4">
              <div class="tit">全方位数据安全保障</div>
              <div class="con">通过WAF准确识别和拦截SQL注入、XSS、信息泄露等威胁，以及敏感数据发现、数据脱敏和数据库审计、数据加密等服务们提供全方位的专业拖库、扫库防御方案，保护客户数据安全</div>
            </div>
          </el-col>
        </el-row>
        
      </div>
    </div>
    <div class="jjfa" id="home2" v-show="show">
      <div class="top">
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :span="24" :offset="0" align="center">
            <div class="tit">解决方案</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="tittit"  type="flex" justify="space-around">
          <el-col :span="6" :offset="0" align="left" >
            <span style="cursor: pointer;" :class="active==1?'bor':''" @click="active=1">
              商业信贷解决方案
            </span>
          </el-col>
          <el-col :span="8" :offset="0" align="center" >
            <span style="cursor: pointer;" :class="active==2?'bor':''" @click="active=2">
              供应链+解决方案
            </span>
          </el-col>
          <el-col :span="6" :offset="0" align="right" >
            <span style="cursor: pointer;" :class="active==3?'bor':''" @click="active=3">
              商业增信解决方案
            </span>
          </el-col>
        </el-row>        
      </div>
      <div class="xian"></div>
      <div class="con" v-show="active==1">
        <el-row :gutter="20" type="flex" justify="center" class="row">
          <el-col :span="24" :offset="0" align="center">
            <div class="tit">
              为中小微企业资信业务整个生命周期进行全覆盖，包含企业贷前信用评估、贷中风控尽调以及贷后监测预警
            </div>
          </el-col>          
        </el-row>
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :span="24" :offset="0" align="center">
            <img src="../assets/img-syxd.png" alt="" class="img">
          </el-col>
        </el-row>        
      </div>
      <div class="con" v-show="active==2">
        <el-row :gutter="20" type="flex" justify="center" class="row">
          <el-col :span="24" :offset="0" align="center">
            <div class="tit">
              通过汇安有智的大数据与人工智能技术，深耕企业上下游关联信息数据的收集、分析、建模以及输出等方便，为供应链金融业务提供了更精准的需求匹配
            </div>
          </el-col>          
        </el-row>
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :span="24" :offset="0" align="center">
            <img src="../assets/img-gyl.png" alt="" class="img">
          </el-col>
        </el-row>        
      </div>
      <div class="con" v-show="active==3">
        <el-row :gutter="20" type="flex" justify="center" class="row">
          <el-col :span="24" :offset="0" align="center">
            <div class="tit">
              还原真实企业信息，弥补企业商业信用板块的数据缺失，通过企业各种能力分析来增加企业的信用等级
            </div>
          </el-col>          
        </el-row>
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :span="24" :offset="0" align="center">
            <img src="../assets/img-syzx.png" alt="" class="img">
          </el-col>
        </el-row>        
      </div>
    </div>
    <div class="jsnl" id="home3" v-show="show">
      <div class="kuan">
        <el-row type="flex"  justify="center">
          <el-col :span="24" align="center"><div class="tit">技术能力</div></el-col>
        </el-row>
         <el-row type="flex"  justify="center">
          <el-col :span="24" align="center"><div class="con">更系统的风控能力   ·   更全面的客户信息   ·   更及时的风险预警   ·   更稳健的信息安全</div></el-col>
        </el-row>
        <el-row :gutter="20" class="rowf">
          <el-col :span="8" :offset="0">
            <div class="col">
              <div class="left">
                <div class="tit">高灵敏 · 事件监测</div>
                <div class="con1">全网布点的舆情监控</div>
                <div class="con1">自定义事件的全链路追踪</div>
                <div class="con1">标志性事件的汇总及沉淀</div>
              </div>
              <div class="right"><img src="../assets/ii-sjjc.png" alt=""></div>
            </div>
          </el-col>
          <el-col :span="8" :offset="0">
            <div class="col">
              <div class="left">
                <div class="tit">高性能 · 决策引擎</div>
                <div class="con1">业务策略的全生命周期管理 </div>
                <div class="con1">可视化的业务策略和规则的编辑</div>
                <div class="con1">低延时的业务策略执行引擎</div>
              </div>
              <div class="right"><img src="../assets/ii-jcyq.png" alt=""></div>
            </div>
          </el-col>
          <el-col :span="8" :offset="0">
            <div class="col">
              <div class="left">
                <div class="tit">高智能 · 数据分析</div>
                <div class="con1">高真实性数据的全面清洗及沉淀</div>
                <div class="con1">专业的各领域模型构建</div>
                <div class="con1">高效的基于机器学习的模型训练</div>
              </div>
              <div class="right"><img src="../assets/ii-sjfx.png" alt=""></div>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="20" justify="space-between">
          <el-col :span="12" align="left" ><div class="col">
            <div class="left">
                <div class="tit">高可靠 · 开放平台</div>
                <div class="con1">友好的开放协议，保证服务接入的便利性</div>
                <div class="con1">异地双活机房方案，保证服务能力的高稳定性输出</div>
                <div class="con1">多重备份保护机制，保证数据的不丢失</div>
              </div>
              <div class="right"><img src="../assets/ii-kfpt.png" alt=""></div></div></el-col>
          <el-col :span="12" align="left" ><div class="col">
            <div class="left">
                <div class="tit">高安全 · 应用系统</div>


                <div class="con1">专业的安全防护方案，防止DDos攻击和网络渗透入侵</div>
                <div class="con1">使用SSL加密通道技术，保证数据传输过程的安全</div>
                <div class="con1">对用户空间的有效隔离，对用户数据的加密存储，确保用户数据不会泄露</div>
              </div>
              <div class="right"><img src="../assets/ii-xtyy.png" alt=""></div></div></el-col>
        </el-row>
      </div>
      
    </div>
    <div class="hzkh" id="home4" v-show="show">
      <div class="kuan">
        <el-row type="flex"  justify="center">
          <el-col :span="24" align="center">
            <div class="tit">合作客户</div>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="20" justify="space-between" class="img11">
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-1.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-2.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-3.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-4.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-5.png" alt="">
            </div>
          </el-col>
          
        </el-row>
        <el-row type="flex" :gutter="20" justify="space-between" class="img11">
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-6.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-7.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-8.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-9.png" alt="">
            </div>
          </el-col>
          <el-col :span="4-8" align="left" >
            <div>
              <img src="../assets/hh-10.png" alt="">
            </div>
          </el-col>
        </el-row>
        
      </div>
    </div>
    <div class="gywm" id="home5" v-show="!show">
      <el-row type="flex" class="row" justify="space-between">
        <el-col :span="16">
          <div class="col1">杭州汇安有智科技有限公司</div>
          <div class="col3">成立于 2016 年，总部位于杭州，是一家专注于提供智能分析与风控服务的科技公司。</div>
          <div class="col3">基于汇安有智对人工智能的理解与实践，通过独有的算法规则以及模型，深挖企业经营数据，为企业间互信搭建桥梁。</div>
          <div class="col3">汇安有智创始团队来自于阿里巴巴、腾讯、平安集团、广发银行、同盾科技、冰鉴科技 、有赞、e签宝等明星企业，在企业业务安全领域有着丰富的创业及从业经历。</div>
        
        </el-col>
        <el-col :span="12">
          
        </el-col>
      </el-row>
    </div>
    <div class="rtxmy">
      <el-row type="flex" class="row" justify="center">
        <el-col :span="24" align="center">
          <span class="con">让天下没有难以防范的风险 </span>
          <span class="sqsy" @click="dialogFormVisible = true">申请试用</span>
        </el-col>
      </el-row>
    </div>
    <div class="lxfs" >
      <el-row type="flex" class="row" justify="space-between">
        <el-col :span="24"><div class="ddd"><img src="../assets/lxwm.png" alt=""></div></el-col>
      </el-row>
    </div>
    <div class="fff">
      <el-row type="flex" class="row" justify="center">
        <el-col :span="24" align="center"><div class="ddd">Copyright © 杭州汇安有智科技有限公司 版权所有 ｜ <a style="color: #fff;text-decoration:none;" href="https://beian.miit.gov.cn">浙ICP备2021011545号</a></div></el-col>
      </el-row>
    </div>
    <el-dialog title="申请试用" :visible.sync="dialogFormVisible" width="25%">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
        <el-form-item label="公司全称：" prop="corporate_name">
          <el-input v-model="form.corporate_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话：" prop="mobile">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱：" >
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="联系人职务：" >
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        
      </el-form>
      <div class="tjsq" @click="app">提交申请</div>
    </el-dialog>
  </div>  
</template>

<script>
import {api} from '../js/api'
// @ is an alias to /src
import BackToTop from "@/components/backToTop.vue";
export default {
  name: "Home",
  components: {
    BackToTop,
  },
  data() {
    return {
      show:true,
      active:1,
      dialogFormVisible :false,
      form: {
          corporate_name: '',
          name: '',
          mobile: '',
          email: '',
          position: ''
        },
         rules: {
          corporate_name: [
            { required: true, message: '请输入公司全称', trigger: 'blur' },
          ],
          name: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          ],
          mobile: [
            { required: true, message: '请输入联系人电话', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '联系人邮箱', trigger: 'blur' },
          ],
          position: [
            { required: true, message: '请输入联系人职务', trigger: 'blur' },
          ],
         }
    };
  },
  methods:{
    app(){
      let params=this.form
      this.$post(api.apply,params).then(res=>{    
        if(res.code==200){
          this.$message(res.msg);
          this.dialogFormVisible=false
        }else{
          this.$message.error(res.msg);
        }
         
      })
    }
  },
  created(){
  }
};
</script>

<style lang="less" scoped>
.home{
  // height: 4472px;
  // overflow-x: auto;
  height: 100vh;overflow-x: hidden;
  .daohang{
    // padding:0 20%;
    background-color: #152054;
    height: 70px;
    line-height: 70px;
    color: #fff;
    display: flex;
    justify-content: center;    
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%; 
      .row{
        width: 1200px;
      }
      .tiaoz{
        a{
          color: #fff;
          text-decoration:none;
        }
      }
  }
  .gywm{
    // padding:0 20%;
    height: 750px;
    background: url('../assets/bannner2.jpg') no-repeat center;
    background-size: 1300px 750px;
    background-color: #152054;
    display: flex;
    justify-content: center;
    .row{
      width: 1200px;
      .col1{
        color: #32DDE4 ;
        margin-top: 150px;
        font-size: 48px;
      }
      .col2{
        color: #32DDE4 ;
        font-size: 48px;
        margin-top: 15px;
      }
      .col3{
        color: #fff ;
        font-size: 16px;
        margin-top: 33px;
        line-height: 34px;
      }
      .col4{
        color: #fff ;
        font-size: 16px;
        margin-top: 10px;
      }
      .col5{
        color: #152054 ;
        font-size: 16px;
        margin-top: 25px;
        background-color: #32DDE4 ;
        padding:15px 20px;
        width: 70px;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
  .banner{
    // padding:0 20%;
    height: 670px;
    // background: url('../assets/banner.png') no-repeat right;
    // background-size: 1200px 600px;
    background-color: #152054;
    display: flex;
    justify-content: center;
    .row{
      width: 1200px;
      .col1{
        color: #32DDE4 ;
        margin-top: 150px;
        font-size: 48px;
      }
      .col2{
        color: #32DDE4 ;
        font-size: 48px;
        margin-top: 15px;
      }
      .col3{
        color: #fff ;
        font-size: 16px;
        margin-top: 15px;
      }
      .col4{
        color: #fff ;
        font-size: 16px;
        margin-top: 10px;
      }
      .col5{
        color: #152054 ;
        font-size: 16px;
        margin-top: 25px;
        background-color: #32DDE4 ;
        padding:15px 20px;
        width: 70px;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
  .chanping{
    background-color: #F5F9FB;
    color: rgba(20,27,102,0.65) ;
    display: flex;
    justify-content: center; 
    height: 1250px;
    .rowall{
      width:1200px;
      display: flex;
      justify-content: center; 
      flex-direction:column;
      .cpyfw{
        color: rgba(20,27,102,1);
        font-size: 42px;
        line-height: 60px;
        margin-top: 120px;
      }
      .cpyfwsm{
        color: rgba(20,27,102,0.65);
        font-size: 16px;
        margin-top: 25px;
        margin-bottom: 60px;
      }
      .img{
        width: 100%;
      }
      .cp1{
        color: rgba(20,27,102,1);
        font-size: 36px;
        margin-top: 40px;
      }
      .cp2{
        color: rgba(20,27,102,0.65);
        font-size: 14px;
        margin-top: 20px;
      }
      .cp3{
        color: rgba(20,27,102,0.65);
        font-size: 24px;
        margin-top: 40px;
      }
      .cp4{
        color: rgba(20,27,102,0.65);
        font-size: 14px;
        margin-top: 40px;
      }
      .cp5{
        color: rgba(20,27,102,0.65);
        font-size: 14px;
      }
      .cp6{
        color: rgba(20,27,102,0.65);
        font-size: 14px;
        margin-top: 40px;
      }
      .cp7{
        color: rgba(20,27,102,0.65);
        font-size: 14px;
      }
      .cpys{
        color: rgba(20,27,102,0.65);
        font-size: 24px;
        height: 100px;
        line-height: 100px;
      }
      .rowf{
        margin-bottom: 80px;
        .ys1{
          background: url('../assets/img-ys1.png') no-repeat -20px;
          background-size: 325px 440px;
          background-color: #fff;
          height: 400px;
          padding:0 32px;
          .tit{
            color: rgba(20,27,102,0.85);
            font-size: 20px;
            padding-top: 180px ;
          }
          .con{
            margin-top: 10px;
            color: rgba(20,27,102,0.65);
            font-size: 14px;
          }
        }
        .ys2{
          background: url('../assets/img-ys2.png') no-repeat -20px;
          background-size: 325px 440px;
          background-color: #fff;
          height: 400px;
          padding:0 32px;
          .tit{
            color: rgba(20,27,102,0.85);
            font-size: 20px;
            padding-top: 180px ;
          }
          .con{
            margin-top: 10px;
            color: rgba(20,27,102,0.65);
            font-size: 14px;
          }
        }
        .ys3{
          background: url('../assets/img-ys3.png') no-repeat -20px;
          background-size: 325px 440px;
          background-color: #fff;
          height: 400px;
          padding:0 32px;
          .tit{
            color: rgba(20,27,102,0.85);
            font-size: 20px;
            padding-top: 180px ;
          }
          .con{
            margin-top: 10px;
            color: rgba(20,27,102,0.65);
            font-size: 14px;
          }
        }
        .ys4{
          background: url('../assets/img-ys4.png') no-repeat -20px;
          background-size: 325px 440px;
          background-color: #fff;
          height: 400px;
          padding:0 32px;
          .tit{
            color: rgba(20,27,102,0.85);
            font-size: 20px;
            padding-top: 180px ;
          }
          .con{
            margin-top: 10px;
            color: rgba(20,27,102,0.65);
            font-size: 14px;
          }
        }
      }
      
    }
  }
  .jjfa{
    background: url('../assets/img-jjfa.png') no-repeat;
    background-size: 100% 800px;
    color: #fff;
    display: flex;
    justify-content: center; 
        flex-direction: column;
    align-content: center;
        overflow-x: clip;
        height: 800px;
    .top{
      height: 200px;
      overflow-x: clip;
      display: flex;
      justify-content: center; 
      flex-direction:column;
      // flex-wrap: wrap;
      align-items: center;
      align-content: center;
      .tit{
        color: rgba(50,221,228,1);
        font-size: 42px;
        margin-top: 60px;
        width: 100%;
      }
      .tittit{
        width: 1200px;
        margin-top: 45px;
        color: rgba(50,221,228,1);
        font-size: 20px;
        // border-bottom: 1px solid rgba(50,221,228,1);
        .bor{
          border-bottom: 4px solid rgba(50,221,228,1);
          display: inline-block;
          height: 36px;
        }
        
      }
      
    }
    .xian{
      border-top: 1px solid rgba(255,255,255,0.1);
    }
    .con{
      // width: 1200px;
      display: flex;
      flex-direction: column;
      .tit{
        color: rgba(255,255,255,1);
        font-size: 16px;
        height: 100px;
        line-height: 100px;
      }
    }
  }
  .jsnl{
    color: #141B66;
    display: flex;
    justify-content: center; 
    height: 730px;
    .kuan{
      width: 1200px;
      display: flex;
      justify-content: center; 
      flex-direction:column;
      .tit{
        color: rgba(20,27,102,1);
        font-size: 42px;
        margin-top: 60px;
      }
      .con{
        color: rgba(20,27,102,0.65);
        font-size: 16px;
        line-height: 70px;
      }
      .col{
        background-image: linear-gradient(180deg, #F5F9FB 0%, #F1F4F9 99%);
        height: 220px;
        margin-top: 20px;
        display: flex;
        .left{
          flex: 1;
          padding: 0 30px;
          .tit{
            color: rgba(20,27,102,0.85);
            font-size: 20px;
            margin-top: 36px;
            margin-bottom: 10px;
          }
          .con1{
            color: rgba(20,27,102,0.65);
            font-size: 14px;
          }
        }
        .right{
          width: 150px;
          text-align: center;
          img{
            margin-top: 100px;            
          }
        }
      }
    }
  }
  .hzkh{
    background-color:  #F5F9FB;
    color: #141B66;
    display: flex;
    justify-content: center; 
    height: 460px;
    .kuan{
      width: 1200px;
      display: flex;
      justify-content: center; 
      flex-direction:column;
      .tit{
        color: rgba(20,27,102,1);
        font-size: 42px;
        // margin-top: 60px;
        line-height: 120px;
      }
      .img11{
        margin-top: 20px;
      }
    }
  }
  .rtxmy{
    // padding:0 20%;
    background:url('../assets/rtxmy.png') no-repeat;
    background-size: 100% 240px;
    height: 240px;
    line-height: 240px;
    color: #fff;
    display: flex;
    justify-content: center;     
      .row{
        width: 1200px;
        .con{
          color: rgba(255,255,255,1);
          font-size: 42px;
          height: 60px;
          vertical-align:middle
        }
        .sqsy{
            display: inline-block;
            background-image: linear-gradient(0deg, #E6FEFF 4%, #FFFFFF 97%);
            box-shadow: 0 3px 4px 0 rgba(0,0,0,0.09);
            border-radius: 2px;
            height: 56px;
            line-height: 56px;
            color: rgba(50,221,228,1);
            font-size: 16px;
            padding: 0 48px;
            cursor: pointer;
          }
      }
  }
  .lxfs{
    background-color: #0d2352;
    height: 180px;
    line-height: 180px;
    color: #fff;
    display: flex;
    justify-content: center;     
      .row{
        width: 1200px;
        .ddd{
          height: 180px;
          img{
            margin-top: 30px;
          }
        }
      }
  }
  .fff{
    background-color: #091a3c;
    height: 70px;
    line-height: 70px;
    color: rgba(245,249,251,1);
    font-size: 14px;
    display: flex;
    justify-content: center;     
      .row{
        width: 1200px;
      }
  }

  .tjsq{
    background: #32DDE4;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
</style>